import React from 'react';

const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
  'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
];

function formatDate(date) {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours %= 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  const strTime = `${hours}:${minutes} ${ampm}`;
  return `${monthNames[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()} ${strTime}`;
}

module.exports = {
  createGuid() {
    const s4 = () =>
      Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  },

  urlify(text = '') {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const textParts = text.split(urlRegex);

    function isUrlPart(i) {
      return i % 2 === 0;
    }

    return textParts.map((part, i) => isUrlPart(i) ? part : <a key={i} href={part} target="_blank" rel="noopener noreferrer">{part}</a>);
  },

  relativeDate(date) {
    const delta = Math.round((Number(new Date()) - new Date(date)) / 1000);

    const minute = 60,
      hour = minute * 60,
      day = hour * 24,
      week = day * 7;


    if (delta < minute) {
      return 'a few seconds ago';
    } else if (delta < 2 * minute) {
      return 'a minute ago';
    } else if (delta < hour) {
      return `${Math.floor(delta / minute)} minutes ago`;
    } else if (Math.floor(delta / hour) === 1) {
      return 'an hour ago';
    } else if (delta < day) {
      return `${Math.floor(delta / hour)} hours ago`;
    } else if (delta < day * 2) {
      return 'yesterday';
    } else if (delta < week) {
      return `${Math.floor(delta / day)} days ago`;
    } else if (delta < week * 2) {
      return 'a week ago';
    } else {
      return formatDate(new Date(date));
    }
  },

  diffMinutes(prev, after) {
    const diffMs = after - prev;
    return Math.round(((diffMs % 86400000) % 3600000) / 60000);
  },

  rgbToHex(rgb) {
    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return (rgb && rgb.length === 4) ? '#' +
      ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) +
      ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) +
      ('0' + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
  }
};



// WEBPACK FOOTER //
// ./chat-app/utils/utils.js